"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = "\n<svg \n\tclass=\"icon-correct-checkmark\"\n\tversion=\"1.1\" \n\tviewBox=\"0 0 24 24\" \n\twidth=\"24px\" \n\theight=\"24px\" \n\trole=\"img\" \n\taria-label=\"checkmark\">\n\t\t<polyline \n\t\t\tfill=\"none\" \n\t\t\tstroke=\"#000\" \n\t\t\tstroke-width=\"2\" \n\t\t\tpoints=\"2 14 9 20 22 4\">\n\t\t</polyline>\n</svg>";
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJjb3JyZWN0LWNoZWNrbWFyay5qcyIsInNvdXJjZXNDb250ZW50IjpbXX0=